import React, { useState } from 'react';
import { TextField } from '@mui/material';

const TestNepaliDatePicker = () => {
  const [date, setDate] = useState('');
  return (
    <div style={{ padding: 40 }}>
      <h2>Date Picker Test</h2>
      <TextField 
        type="date"
        value={date} 
        onChange={(e) => setDate(e.target.value)} 
        fullWidth 
        size="small"
        InputLabelProps={{
          shrink: true,
        }}
      />
      <div style={{ marginTop: 20 }}>
        <strong>Selected Date:</strong> {date}
      </div>
    </div>
  );
};

export default TestNepaliDatePicker;
